import { render, staticRenderFns } from "./ConfigurationPage.vue?vue&type=template&id=790c988a&scoped=true"
import script from "./ConfigurationPage.vue?vue&type=script&lang=js"
export * from "./ConfigurationPage.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationPage.vue?vue&type=style&index=0&id=790c988a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790c988a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemTitle})
